export default "__VITE_ASSET__7bd9af4c__"